import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/pme";
import { types as authTypes } from "../reducers/authentication";
import { CaddService, SiteService, StakeholderService } from "../../services";
import ErrorFormat from '../../helpers/FormatErrors';

function* submitAdditionalInformation({ value }) {
  try {
    const {
      data: user,
    } = yield call(() => CaddService.submitAdditionalInformation({ ...value, module: 'pme' }));
    if (user) {
      yield put({ type: types.ADDITIONAL_INFORMATION_SUCCEDDED_PME, value: user });
      yield put({ type: authTypes.AUTHENTICATION_SUCCEDDED, value: user });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_SITE_FAILED,
        value: errors,
      });
    }
  }
}

function* getSites() {
  try {
    const { data } = yield call(() => SiteService.get());
    if (data) {
      yield put({ type: types.GET_SITES_SUCCEDDED, value: data.length === 0 ? 'no-sites' : data });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_SITE_FAILED,
        value: errors,
      });
    }
  }
}

function* createSite({ value }) {
  try {
    const { data } = yield call(() => SiteService.create(value));
    if (data) {
      yield put({ type: types.NEW_SITE_SUCCEDDED, value: [] });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_SITE_FAILED,
        value: errors,
      });
    }
  }
}

function* getStakeholders() {
  try {
    const { data } = yield call(() => StakeholderService.get());
    if (data) {
      yield put({ type: types.GET_STAKEHOLDERS_SUCCEDDED, value: data.length === 0 ? 'no-stakeholders' : data });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_STAKEHOLDER_FAILED,
        value: errors,
      });
    }
  }
}

function* createStakeholder({ value }) {
  try {
    const { data } = yield call(() => StakeholderService.create(value));
    if (data) {
      yield put({ type: types.NEW_STAKEHOLDER_SUCCEDDED, value: [] });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_STAKEHOLDER_FAILED,
        value: errors,
      });
    }
  }
}

export default function* init() {
  yield takeEvery(
    types.ADDITIONAL_INFORMATION_REQUESTED_PME,
    submitAdditionalInformation
  );
  yield takeEvery(
    types.GET_SITES_REQUESTED,
    getSites,
  )
  yield takeEvery(
    types.NEW_SITE,
    createSite
  );
  yield takeEvery(
    types.GET_STAKEHOLDERS_REQUESTED,
    getStakeholders
  );
  yield takeEvery(
    types.NEW_STAKEHOLDER,
    createStakeholder
  )
}
